import React, { Component } from "react";

import { aggregateStats } from "../../lib/stats/utils";
import knownAgentFriendlyNames from "../../../lib/known_agent_friendly";
import StatsPageTable from "./stats_page_table";

const columnInfo = [
  {
    accessor: "app",
    Header: "App",
  },
  {
    id: "count",
    accessor: "count",
    Header: "Downloads",
    Cell: ({ row }) => (row.count || 0).toLocaleString(),
  },
];
class StatsAppTable extends Component {
  render() {
    return (
      <div className="stats-table">
        <h3>Downloads By App</h3>
        <StatsPageTable
          data={this.getData()}
          columns={columnInfo}
          defaultSorted={[
            {
              id: "count",
              desc: true,
            },
          ]}
        />
      </div>
    );
  }

  getData = () => {
    var data = aggregateStats(this.props.data, {});
    return Object.keys(data)
      .filter(key => key)
      .map(app => {
        return { count: data[app].count, app: knownAgentFriendlyNames.get("app", app) };
      });
  };
}

export default StatsAppTable;
